import * as React from 'react'
import { useParams } from 'react-router-dom'

import { Box, NotFound } from '@factorialco/deprecated-design-system'
import { AnimatePresence, motion } from 'framer-motion'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { Carousel } from 'modules/marketplace/components/Carousel'
import { locale } from 'modules/marketplace/components/utils/locales'
import { useGetMarketplaceIntegrations } from 'modules/marketplace/hooks/integrations/useGetMarketplaceIntegrations'
import { useCompanyInstallations } from 'modules/marketplace/store/collections/companyInstallations'
import type CompanyInstallation from 'modules/marketplace/store/models/companyInstallations'

import { IntegrationAside } from './IntegrationAside'
import { IntegrationData } from './IntegrationData'
import './index.styles.css'
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
}

export const Content = () => {
  const {
    access: { locale: user_locale },
  } = useCurrentSession()

  const { id } = useParams()
  const datoFormatLocale = locale[user_locale]
  const companyInstallation = React.useRef<CompanyInstallation | null | undefined>(null)
  const companyInstallations = useCompanyInstallations()

  const { data: integrationsData, loading: loadingIntegration } = useGetMarketplaceIntegrations({
    locale: datoFormatLocale,
    datoIds: [id!],
  })

  const integration = integrationsData.find((e) => e.datoId === id)
  const integrationId = integration?.id

  const { loading } = useAsyncData(async () => {
    if (integration?.component === false) return

    await companyInstallations.fetch()
    companyInstallation.current = companyInstallations.find({
      integration_id: integrationId!,
    })
  }, [])

  if (loading || loadingIntegration) return <Loading />

  if (!integration) {
    return (
      <NotFound
        title={i18n.t('errors.page_not_found.title')}
        description={i18n.t('errors.page_not_found.description')}
      />
    )
  }

  const images = integration.images?.map((image) => image.url) ?? []

  const carouselImages = images.map((carouselItem) => {
    const imgObj = {
      url: carouselItem,
      alt: '',
    }
    return imgObj
  })

  return (
    <AnimatePresence>
      <motion.div layout variants={container} initial="hidden" animate="show">
        <Box className={'Item_carouselWrapper'}>
          <Box width="fit-content">
            {carouselImages && <Carousel media={carouselImages} />}
            <IntegrationData integration={integration} />
          </Box>
          <IntegrationAside integration={integration} />
        </Box>
      </motion.div>
    </AnimatePresence>
  )
}
